import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Button,
  Icon
} from 'semantic-ui-react'

const CardAddSurgeryTeamUX = (props: any) => {
    return(
      <div
        id="CardAddSurgeryTeam"
        style={{width:"100%", padding: "1rem"}}>
        <div
          className="ui form"
          id="CardAddSurgeryTeamUX-div-1">
          
          <FormGroup
            id="CardAddSurgeryTeamUX-FormGroup-2"
            inline={true}>
            <FormField
              className="required"
              id="CardAddSurgeryTeamUX-FormField-4"
              inline={true}>
              <label
                id="CardAddSurgeryTeamUX-label-8"
                style={{minWidth: "55px", maxWidth: "55px"}}>
                {props.languageUX === "en" ? "Primary surgeon" : "แพทย์ผ่าตัดหลัก"}
              </label>
            </FormField>
            <FormField
              id="CardAddSurgeryTeamUX-FormField-5"
              inline={true}
              width={6}>
              <div
                id="CardAddSurgeryTeamUX-div-33"
                style={{width:"100%"}}>
                {props.chiefSurgeon}
              </div>
            </FormField>
            <FormField
              id="CardAddSurgeryTeamUX-FormField-17"
              inline={true}
              style={{flex:1}}>
            </FormField>
            <FormField
              id="CardAddSurgeryTeamUX-FormField-6"
              inline={true}
              style={{padding: 0}}>
              <Button
                color={"red"}
                disabled={props.isMain ? true : false}
                id="CardAddSurgeryTeamUX-Button-12"
                onClick={props.handleDeleteTeam}>
                <Icon
                  id="CardAddSurgeryTeamUX-Icon-15"
                  name={"trash"}>
                </Icon>
                <label
                  id="CardAddSurgeryTeamUX-label-16">
                  {props.languageUX === "en" ? "Delete Team" : "ลบทีม"}
                </label>
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAddSurgeryTeamUX-FormGroup-3">
            <FormField
              id="CardAddSurgeryTeamUX-FormField-18"
              inline={true}>
              <label
                id="CardAddSurgeryTeamUX-label-28"
                style={{minWidth: "55px", maxWidth: "55px"}}>
                {props.languageUX === "en" ? "Associate surgeon" : "แพทย์ผ่าตัดร่วม"}
              </label>
            </FormField>
            <FormField
              id="CardAddSurgeryTeamUX-FormField-13"
              inline={true}
              width={14}>
              <div
                id="CardAddSurgeryTeamUX-div-14"
                style={{width: "100%"}}>
                {props.assistant_surgeons}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAddSurgeryTeamUX-FormGroup-22">
            <FormField
              className="required"
              id="CardAddSurgeryTeamUX-FormField-24"
              inline={true}>
              <label
                id="CardAddSurgeryTeamUX-label-31">
                {props.languageUX === "en" ? "Scrub Nurse" : "พยาบาล scrub"}
              </label>
            </FormField>
            <FormField
              id="CardAddSurgeryTeamUX-FormField-39"
              inline={true}>
              <Button
                color="green"
                icon="plus"
                id="CardAddSurgeryTeamUX-Button-40"
                onClick={props.onAddScrubNurse}>
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAddSurgeryTeamUX-FormGroup-34">
            <FormField
              id="CardAddSurgeryTeamUX-FormField-37"
              inline={true}
              width={16}>
              <div
                id="CardAddSurgeryTeamUX-div-38">
                {props.scrub_nurses}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAddSurgeryTeamUX-FormGroup-23">
            <FormField
              className="required"
              id="CardAddSurgeryTeamUX-FormField-26"
              inline={true}>
              <label
                id="CardAddSurgeryTeamUX-label-32">
                {props.languageUX === "en" ? "Circulating Nurse" : "พยาบาล circulating"}
              </label>
            </FormField>
            <FormField
              id="CardAddSurgeryTeamUX-FormField-46"
              inline={true}>
              <Button
                color="green"
                icon="plus"
                id="CardAddSurgeryTeamUX-Button-47"
                onClick={props.onAddCirculatingNurse}>
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAddSurgeryTeamUX-FormGroup-41">
            <FormField
              id="CardAddSurgeryTeamUX-FormField-44"
              inline={true}
              width={16}>
              <div
                id="CardAddSurgeryTeamUX-div-45">
                {props.circulating_nurses}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardAddSurgeryTeamUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeam"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"1rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormGroup-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผ่าตัดหลัก",
          "valueEN": "Primary surgeon"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-label-8"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"55px\", maxWidth: \"55px\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Button",
      "parent": 6,
      "props": {
        "color": {
          "type": "code",
          "value": "\"red\""
        },
        "disabled": {
          "type": "code",
          "value": "props.isMain ? true : false"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-Button-12"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleDeleteTeam"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.assistant_surgeons"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Icon",
      "parent": 12,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-Icon-15"
        },
        "name": {
          "type": "code",
          "value": "\"trash\""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "ลบทีม",
          "valueEN": "Delete Team"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormGroup-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormGroup-23"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 22,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 23,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผ่าตัดร่วม",
          "valueEN": "Associate surgeon"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-label-28"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"55px\", maxWidth: \"55px\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาล scrub",
          "valueEN": "Scrub Nurse"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-label-31"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาล circulating",
          "valueEN": "Circulating Nurse"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-label-32"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.chiefSurgeon"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormGroup-34"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "props.scrub_nurses"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-div-38"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 22,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-39"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Button",
      "parent": 39,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-Button-40"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddScrubNurse"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormGroup-41"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "code",
          "value": "props.circulating_nurses"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-div-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Button",
      "parent": 46,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardAddSurgeryTeamUX-Button-47"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddCirculatingNurse"
        }
      },
      "seq": 47,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardAddSurgeryTeamUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
